import React from 'react';

interface DetailViewField {
  label: string;
  value: string | number | React.ReactNode;
  isBadge?: boolean;
  span?: number; // For grid layout, how many columns this field should span
}

interface DetailViewProps {
  title?: string;
  fields: DetailViewField[];
  actions?: React.ReactNode;
  layout?: 'flex' | 'grid';
  columns?: number; // For grid layout
  className?: string;
  noWrapper?: boolean; // If true, don't wrap in card (useful when already inside a card)
}

const DetailView: React.FC<DetailViewProps> = ({
  title,
  fields,
  actions,
  layout = 'flex',
  columns = 3,
  className = '',
  noWrapper = false
}) => {
  const containerStyle = layout === 'grid' 
    ? {
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: '24px',
        marginBottom: '24px'
      }
    : {};

  const content = (
    <>
      {/* Header with Title and Actions */}
      {(title || actions) && (
        <>
          <div className="seller-detail-header">
            {title && <h3 className="seller-detail-title">{title}</h3>}
            {actions && <div className="seller-detail-actions">{actions}</div>}
          </div>
          <hr className="seller-detail-divider" />
        </>
      )}
      
      {/* Fields Layout */}
      <div 
        className="seller-detail-info" 
        style={containerStyle}
      >
        {fields.map((field, index) => (
          <div 
            key={index} 
            className="seller-detail-meta-item"
            style={layout === 'grid' && field.span ? { gridColumn: `span ${field.span}` } : {}}
          >
            <span className="seller-detail-label">{field.label}:</span>
            {field.isBadge ? (
              <div className="seller-detail-badge-wrapper">
                {field.value}
              </div>
            ) : (
              <span className="seller-detail-value">{field.value}</span>
            )}
          </div>
        ))}
      </div>
    </>
  );

  if (noWrapper) {
    return <div className={className}>{content}</div>;
  }

  return (
    <div className={`seller-detail-card ${className}`}>
      <div className="card-body">
        {content}
      </div>
    </div>
  );
};

export default DetailView;